__turbopack_context__.v({
  "className": "inter_tight_a2010230-module__-9fGaW__className",
});
